import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CongratulationComponent } from '../../../../../../shared/components/congratulation/congratulation.component';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { CurrencyExchangeService } from '../../../../../../shared/services/currency-exchange.service';
import { GetBusinessProfileService } from '../../../../../../shared/services/get-business-profile.service';
import { TitledModalWithContentService } from '../../../../../../shared/services/titled-modal-with-content.service';
import { GetCalculatesParamsService } from '../../../../services/get-calculates-params.service';
import { GetCategoryService } from '../../../../services/get-category-name.service';
import { ViewProductInfoHandlerService } from '../../../../services/view-product-info-handler.service';
import { BasePhysicalTemplate } from './basePhysicalTemplate';
import { ProductTypes } from 'src/app/shared/product/productTypes';
import { ProductCreationHelperService } from 'src/app/dashboard/seller/payment-pages/services/product-creation-helper.service';

@Component({
  selector: 'app-physical-product',
  templateUrl: './physical-product.component.html',
  styleUrls: ['./physical-product.component.scss']
})
export class PhysicalProductComponent extends BasePhysicalTemplate implements OnInit {
  owner = false;
  ActiveQuantity: number = 0;
  url = window.location.href
  fieldsArray: any[] = [];
  quantityArray: any[] = [];
  code = this.url.split('/')[3];
  categoryName: string = '';
  Business: any;
  @Input() productObject: any;
  businessObject: any;

  constructor(
    public dialog: MatDialog,
    vpihs: ViewProductInfoHandlerService,
    public titledModal: TitledModalWithContentService,
    getBusinesssProfileService: GetBusinessProfileService,
    auth: AuthService,
    public exchangeService: CurrencyExchangeService,
    private getCategoryName: GetCategoryService,
    public  getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productCreationHelperService: ProductCreationHelperService
  ) {
    super(vpihs, getBusinesssProfileService, auth, exchangeService, getCalculatesParamsService);
  }

  async openShareButtonsDialog() {
    this.dialog.open(CongratulationComponent, {
      panelClass: 'responsive-dialog',
      data: {
        url: this.url,
        name: this.productObject['Product name'],
        type: 'Physical',
        showCongratulation: false,
        showButton: false
      }
    });
  }

  async ngOnInit() {
    const imageUrl = this.productObject?.PhysicalProductExtraInfo?.image;
  if (imageUrl) {
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = imageUrl;
    document.head.appendChild(preloadLink);
  }
    this.maxQuantity = (Number(this.productObject['PhysicalProductExtraInfo']['quantity'])) - Number(this.productObject['PhysicalProductExtraInfo']['pendingQuantity']) - Number(this.productObject['PhysicalProductExtraInfo']['paidQuantity'])

    await this.initCurrencies();
    this.owner = await this.ifSeller();
    this.businessObject = this.productObject.Business;

    this.productObject.ProductExtraInfos.forEach((element: any) => {
      this.productObject[element.key] = element.value
    });
    this.fieldsArray = this.productObject;
    let categoryId = <number>this.productObject['PhysicalProductExtraInfo']['ProductTypeCategoryId'];
    this.getCategoryName.setParams({
      id: categoryId
    })

    this.Business = this.productObject.Business;
    const category = await this.getCategoryName.make();
    this.categoryName = category.name;
    this.maxQuantityPerSale = <number>this.productObject['PhysicalProductExtraInfo']['maxQuantityPerSale'] ? Math.min(<number>this.productObject['PhysicalProductExtraInfo']['maxQuantityPerSale'], <number>this.productObject['PhysicalProductExtraInfo']['quantity']) : <number>this.productObject['PhysicalProductExtraInfo']['quantity'] || 0;

    if (!this.maxQuantity) {
      this.quantity = 0;
    }
    this.vpihs.subTotal = this.subtotal = this.vpihs.getExchangedValue(this.getProductValueByFieldName('Product price'), this.getProductValueByFieldName('Currency'))
    this.productCreationHelperService.checkParamsForOpriningCopyDialog(window.location.search, {
      serilizedUrl: this.url?.split("?")[0],
      product: {
        name: this.productObject.productName,
        type: ProductTypes.physical
      }
    })
  }

  calculateSubTotalAmount() {
    return (this.vpihs.subTotal = this.subtotal = this.vpihs.getExchangedValue(
      this.productObject['PhysicalProductExtraInfo']['price'],
      this.getNewProductValueByFieldName("currency", "ProductExtraInfos")
    ));
  }

  animationEvent(type: string) {
    let productCover = document.getElementById('product-cover');
    let infoBar = document.getElementById('info-bar');
    let productCoverTag = document.getElementById('product-cover-tag');
    if (productCover && infoBar && productCoverTag) {
      if (type == 'in') {
        productCoverTag.style.opacity = '.2';
        infoBar.style.marginTop = '2rem';
      } else if (type == 'out') {
        productCoverTag.style.opacity = '1';
        infoBar.style.marginTop = '-6rem';
      };
    }
  }

  proceedToPayment() {
    this.vpihs.setViewInfoObject({
      product: this.productObject,
      extras: this.extrasObject
    });
    this.vpihs.BusinessId = this.productObject.BusinessId;
    this.getCalculatesParamsService.setQuantity(this.quantity);
    this.getCalculatesParamsService.calculateInfos();
    this.vpihs.quantity = this.quantity;
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
  }
}
